import PropTypes from 'prop-types';
import React from 'react';
import { Button, Image,ButtonToolbar } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';


class TicketPhoto extends React.Component {
	constructor(props) {
        super(props)
        this.state = {
            showConfirm:false,
            modalText: ''
          };
	}
    handleConfirm = () =>{
        this.setState({showConfirm:true,modalText: 'Are you sure want to remove this attachment?'})
    }

    handleCloseModal = () => {
        this.setState({showConfirm:false})
    }

    handleRemove = () => {
        this.handleRemovePhoto();    
    }

	handleRemovePhoto = () => {
		this.props.handleDeletePhoto(this.props.photo)
    }
    
    buildToolbar() {
        return (
          <ul className="hotel-photo-tools">
            <li>
              <Button onClick={this.handleConfirm} title="Remove"><i className="fa fa-trash" /></Button>
            </li>
          </ul>
        );
      }

	render() {
        const room_photo = this.props.room_photo;
        const toolbar = this.buildToolbar();
        const photo = this.props.photo;
		return (
			<div>
            <div className="col-sm-4 col-md-4">
                <div className="thumbnail">
                    <Image src={photo} responsive />
                    <div className="caption">
                        {toolbar}
                    </div>
                </div>
            </div>

            {this.state.showConfirm && (<Modal show={this.state.showConfirm} onHide={this.handleCloseModal}>
                <Modal.Header closeButton>
                <Modal.Title>Delete Attachment</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                <p> {this.state.modalText !== '' ? this.state.modalText : 'Are you sure want to delete it?'}</p>

                <ButtonToolbar style={{ float: 'right' }}>
                    <Button bsStyle="success" onClick={this.handleRemove}>
                        Confirm
                    </Button>
                    <Button bsStyle="success" onClick={this.handleCloseModal}>
                        Cancel
                    </Button>
                </ButtonToolbar>
                </Modal.Body>
                <Modal.Footer style={{ clear: 'both' }} />
            </Modal>
            )}
  </div>
		);
	}
}

export default TicketPhoto;



// WEBPACK FOOTER //
// src/routes/support/components/TicketPhoto.js